import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchUser, getCookie } from '../actions/user'
import { setBreadcrumb } from '../actions/breadcrumb'

import { RETURN_BREADCRUMBS, CONFIRMATION_BREADCRUMBS, RETURNS, SHIPPING, CHECKOUT, INSTRUCTIONS, TRACKING } from '../assets/constant'

import ReturnItems from './ReturnItems'
import ReturnModes from './ReturnModes'
import ReturnCheckout from './ReturnCheckout'
import ReturnInstructions from './ReturnInstructions'
import ReturnTracking from './ReturnTracking'
import Breadcrumbs from './Breadcrumbs'

import { isEmpty } from '../assets/utils'

import ErrorBoundary from './ErrorBoundary'

var interval = 0

class ReturnApp extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.state = { items: true, return_breadcrumbs: RETURN_BREADCRUMBS, confirmation_breadcrumbs: CONFIRMATION_BREADCRUMBS }
  }

  componentWillMount() {
    I18n.locale = locale
    this.props.fetchUser(shipback_id, user_agent)
  }

  showContactModal() {
    if (!getCookie('user_token')) {
      $('#edit-contact').modal('show');
    }
  }

  renderReturnBreadcrumb() {
    switch(this.props.breadcrumb) {
      case RETURNS:
        if (this.props.items.list.length > 0 && !this.props.items.fetching) {
          this.showContactModal()
          return <ReturnItems />
        } else if (this.props.items.fetching) {
          return(
            <div className="row spinner">
              <div className="col-12">
                <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
                <h3>{I18n.t('shipbacks.items.show.loading')}</h3>
              </div>
            </div>
          )
        } else {
          return(
            <div className="row">
              <div className="col-12 text-center upcase">
                <h4>
                  <span dangerouslySetInnerHTML={{__html: I18n.t('shipbacks.items.impossible_html', { email: this.props.company.company.contact_email })}}></span>
                </h4>
              </div>
            </div>
          )
        }
      case SHIPPING:
        if (this.props.shipback.quotes !== undefined) {
          this.showContactModal()
          return <ReturnModes />
        }
      case CHECKOUT:
        if (this.props.shipback.quotes != undefined) {
          return <ReturnCheckout />
        }
      default:
        return (<div></div>)
    }
  }

  renderConfirmationBreadcrumb() {
    switch(this.props.breadcrumb) {
      case INSTRUCTIONS:
        return <ReturnInstructions />
      case TRACKING:
        return <ReturnTracking />
      default:
        break;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.shipback != undefined && nextProps.shipback.charged == false) {
      if (nextProps.shipback.returned_items.length > 0 && nextProps.shipback.size != undefined && nextProps.breadcrumb != RETURNS && nextProps.breadcrumb != CHECKOUT){
        this.props.setBreadcrumb(SHIPPING)
      } else if (nextProps.breadcrumb != CHECKOUT && this.props.breadcrumb == "") {
        this.props.setBreadcrumb(RETURNS)
      }
    }
    if (nextProps.shipback != undefined && nextProps.shipback.charged && nextProps != this.props && this.props.breadcrumb == CHECKOUT) {
      this.props.setBreadcrumb(INSTRUCTIONS)
    }
  }

  render() {
    if (this.props.user_token != undefined) {
      if (isEmpty(this.props.shipback)) {
        return  (
          <div className="row spinner">
            <div className="col-12">
              <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
              <h3>{I18n.t('initializing')}</h3>
            </div>
          </div>
        )
      } else {
        if(this.props.shipback.charged) {
          return (
            <div className="row">
              <div className="col-12">
                <div className="confirmation">
                  <ErrorBoundary>
                    <Breadcrumbs breadcrumbs={this.state.confirmation_breadcrumbs} />
                    {this.renderConfirmationBreadcrumb()}
                  </ErrorBoundary>
                </div>
              </div>
            </div>
          )
        } else {
          return (
            <div className="row">
              <div className="col-12">
                <ErrorBoundary>
                  <Breadcrumbs breadcrumbs={this.state.return_breadcrumbs} />
                  {this.renderReturnBreadcrumb()}
                </ErrorBoundary>
              </div>
            </div>
          )
        }
      }
    }
  }
}

const mapStateToProps = state => ({
  shipback: state.shipback,
  company: state.company,
  breadcrumb: state.breadcrumb,
  items: state.items,
  user_token: state.user,
  sizes: state.sizes,
})

const mapDispatchToProps = dispatch => bindActionCreators({ fetchUser, setBreadcrumb }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReturnApp)


// WEBPACK FOOTER //
// ./app/javascript/components/components/ReturnApp.jsx